<template>
  <DBox
    :id="'cmp-catalog-products-product_setup'"
    :addButton="false"
    :expandable="false"
   
    
  >
   <!-- :searchButton="true"
    :searchIcon="'static/icons/edit-blue.svg'"
    :searchIconAlt="'static/icons/edit-blue.svg'"
    @searchClick="onEditClick" -->
    <TextField2
      :disabled="selectedProductDetails.disabled"
      :id="'initial_qty'"
      :placeholder="$t('initial_qty')"
      :label="$t('initial_qty')"
      :value="selectedProductDetails.product.initial_qty"
      @blur="onTextFieldValueChange"
      :lw="'120px'"
    />
    <TextField2
      :disabled="selectedProductDetails.disabled"
      :id="'min_stock'"
      :placeholder="$t('min_stock')"
      :label="$t('min_stock')"
      :value="selectedProductDetails.product.min_stock"
      @blur="onTextFieldValueChange"
       :lw="'120px'"
    />
    <TextField2
      :disabled="selectedProductDetails.disabled"
      :id="'box_lot'"
      :placeholder="$t('box_lot')"
      :label="$t('box_lot')"
      :value="selectedProductDetails.product.box_lot"
      @blur="onTextFieldValueChange"
       :lw="'120px'"
       :bb="'none'"
    />

  </DBox>
</template>

<script>
export default {
  props: {
    selectedProductDetails: {
      required: true,
    },
  },
  methods: {
    onTextFieldValueChange: function (event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },

    onEditClick:function(){
      this.$router.push({
        ...this.$route,
        query: {
          modal: "alternate_setup",
          product_id:this.selectedProductDetails.product.product_id
        },
      });
    }
  },
};
</script>

<style lang="scss">
.cmp-catalog-products-product_setup {
}
</style>
